import {FormBuilderPageBlock} from "@/types";
import Question from "@/Components/FormViewer/Question";
import DebugDiv from "@/Components/FormViewer/DebugDiv";
import ReactMarkdown from 'react-markdown';
import rehypeExternalLinks from 'https://esm.sh/rehype-external-links@3'
import React from "react";
import {router, usePage} from "@inertiajs/react";
import PrimaryLink from "@/Components/PrimaryLink";
import Arrow from "@/Components/Icons/Arrow";

interface Props {
    block: FormBuilderPageBlock,
    data: any,
    setData: any,
    showDev: boolean,
    offices: {[string: string]: string},
}

export default function Block({block, data, setData, errors, deleteFiles, officeId, showDev, settings, offices, page, propertyAddress, existingEntryId, journeyId, form }: Props) {

    const {auth} = usePage().props;
    const baseClassName = `relative ${block.is_transparent ? '' : ''}${block.add_spacing ? 'pb-4 ' : ''}${block.show_divider ? 'border-b ' : ''}`
    return (<div className={baseClassName}>
        {showDev ? <DebugDiv>Block ID <strong>{block.id}</strong></DebugDiv> : <></>}
        {block.text && <ReactMarkdown
            rehypePlugins={[[rehypeExternalLinks, { target: '_blank' }]]}
            className={`markdown-preview pt-4 pb-4 [&>p>strong]:font-semibold [&>p]:text-sm [&>p]:leading-5 [&>p]:text-gray-500 [&>h1]:text-3xl [&>h2]:text-2xl [&>p>a]:underline [&>p>a]:text-[${settings.primaryColour}]`}
        >{block.text}</ReactMarkdown>}
        {!auth.user && page.number == 1 && <LoginPrompt officeId={officeId}/>}
        {block.questions.sort((a,b) => a.order - b.order).map((question) => (
            <Question key={question.id} question={question} data={data} setData={setData} errors={errors} deleteFiles={deleteFiles} officeId={officeId} showDev={showDev} settings={settings} offices={offices} />
        ))}
    </div>);
}
function DuplicateResponse({officeId, existingEntryId, propertyAddress, form, journeyId}) {
    return (
        <div
            className={'border border-gray-100 bg-[#FAFAFA] text-gray-700 rounded text-sm px-4 py-4 transition-all ease-in-out delay-1000 overflow-hidden mb-4'}>
            <img src='/icon.png' alt='My Agent Response' className={'h-5'}/>
            <div>It looks like you've filled in this form for another property. Would you like us to copy your previous
                answers for you to review and submit?
            </div>
            <button
                className='w-full bg-green-400 text-gray-900 p-2 text-base font-semibold rounded text-center flex gap-x-2 stroke-gray-900 items-center justify-center mt-2'
                type={'button'}
                onClick={(e) => {
                    e.preventDefault()
                    router.post(route('form-viewer.copy', {
                        form: form.id,
                    }), {
                        propertyAddress: propertyAddress,
                        existingEntry: existingEntryId,
                        office: officeId,
                        journeyId: journeyId
                    });
                }}
            >
                <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M7.15361 12.9848L4.9181 13.73C4.65282 13.8184 4.40045 13.5661 4.48887 13.3008L5.23404 11.0653M7.15361 12.9848L12.9123 7.22615M7.15361 12.9848L6.19383 12.0251L5.23404 11.0653M5.23404 11.0653L10.9927 5.30658M12.9123 7.22615L13.8721 6.26637C14.1371 6.00133 14.1371 5.57162 13.8721 5.30658L12.9123 4.3468C12.6473 4.08176 12.2176 4.08176 11.9525 4.3468L10.9927 5.30658M12.9123 7.22615L11.9525 6.26637L10.9927 5.30658M4.9292 6.5354C4.94384 5.43709 5.83089 4.55023 6.9292 4.5354C5.83081 4.52094 4.94384 3.63379 4.9292 2.5354C4.91456 3.63379 4.02759 4.52094 2.9292 4.5354C4.02751 4.55023 4.91456 5.43709 4.9292 6.5354Z"
                        stroke="#061022"/>
                </svg>
                Autofill With Previous Answers
            </button>

        </div>
    )
}

function LoginPrompt({officeId}: {officeId?: string|null}) {

    return (
        <div
            className={'border border-gray-100 bg-[#FAFAFA] text-gray-700 rounded text-sm px-4 py-4 transition-all ease-in-out delay-1000 overflow-hidden mb-4'}>
            <img src='/icon.png' alt='My Agent Response' className={'h-5'}/>
            <div className=''>Filled in a form before? Or already have an account?</div>
            <PrimaryLink href={route('login', {back: window.location.href, office: officeId})} className='mt-2 '>
                <div>Login to
                    retrieve your answers
                </div>
                <Arrow className={'rotate-180'}/></PrimaryLink>
        </div>)
}

